import TextField from "@/components/layouts/History/TextField";
import { usePeopleJobFunctions } from "@/entities/people/hooks";
import { LookupNameFromIdx } from "@/utils/datamaps";
import { useTranslation } from "react-i18next";

interface Props {
  value: string;
}

const JobFunctionName: React.FC<Props> = ({ value }) => {
  const { t } = useTranslation();
  const jobFunctions = usePeopleJobFunctions().data?.jobFunctions || [];

  const jobFunctionName = LookupNameFromIdx(
    t,
    "people.jobFunctions",
    jobFunctions,
    Number(value)
  );
  return <TextField>{jobFunctionName}</TextField>;
};

export default JobFunctionName;
